import { render } from "./CustomizationSubmitToRetailerBody.vue?vue&type=template&id=87663b6a&scoped=true"
import script from "./CustomizationSubmitToRetailerBody.vue?vue&type=script&lang=js"
export * from "./CustomizationSubmitToRetailerBody.vue?vue&type=script&lang=js"

import "./CustomizationSubmitToRetailerBody.vue?vue&type=style&index=0&id=87663b6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87663b6a"]])

export default __exports__